var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecolor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 13.5913C19.2 17.7493 15.9765 21.12 12 21.12C8.0236 21.12 4.80005 17.7493 4.80005 13.5913C4.80005 9.43331 12 2.39999 12 2.39999C12.1946 2.60347 19.2 9.43331 19.2 13.5913Z",
    fill: "url(#paint0_linear_269_202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2799 17.28C10.3523 17.28 9.51968 16.6765 8.95059 15.7199C8.72004 15.3324 8.53274 14.8868 8.3999 14.4",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_202",
    x1: 17.6,
    y1: 18.2713,
    x2: 7.81476,
    y2: 7.45103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F85623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#FFD600",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#19D263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#1F86DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#CD1FDC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecolor);
export default __webpack_public_path__ + "static/media/recolor.be1816961e7efa8e923f032659a1a475.svg";
export { ForwardRef as ReactComponent };